import Comp from "./LoadingData";

export default Comp;
